import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgMerge = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="m17.341 4 .148.11 6.251 6.234a2.186 2.186 0 0 1 .266 2.774l-.11.147-6.234 6.251a2.186 2.186 0 0 1-2.774.265l-.147-.109-1.328-1.309-1.985 1.986a2.186 2.186 0 0 1-2.774.266l-.147-.11-7.085-7.066a2.186 2.186 0 0 1-.266-2.774l.11-.147L7.5 4.266a2.186 2.186 0 0 1 2.774-.265l.147.109 2.161 2.142 1.985-1.986A2.186 2.186 0 0 1 17.341 4Zm-8.255.832c-.23 0-.484.081-.733.267l-6.088 6.088-.094.108a.992.992 0 0 0-.193.506c-.02.222.025.454.277.785l6.92 6.92.109.094c.15.113.326.178.506.194.222.02.453-.026.785-.278l1.996-1.998-4.27-4.294-.108-.154a2.181 2.181 0 0 1-.344-1.206c.006-.487.178-.97.647-1.526l3.24-3.244L9.753 5.11l-.095-.083a.921.921 0 0 0-.571-.194Zm7.068 0c-.23 0-.484.081-.733.267l-1.998 1.996 4.271 4.297.108.154c.236.367.35.787.344 1.205-.006.487-.178.97-.647 1.527l-3.301 3.3 2.522 1.195 6.177-6.177.094-.109a.992.992 0 0 0 .194-.505c.02-.223-.026-.454-.278-.785l-6.088-6.088-.094-.083a.921.921 0 0 0-.571-.194ZM12.58 7.937l-3.247 3.25-.078.087a.868.868 0 0 0-.187.55c0 .216.072.468.248.755l4.098 4.097 3.248-3.247.078-.088a.868.868 0 0 0 .187-.55c0-.215-.072-.468-.248-.754l-4.1-4.1Z"
      stroke="currentColor"
      strokeWidth={0.4}
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgMerge)
const Memo = memo(ForwardRef)
export default Memo
